import "./SanchalakSamiti.css";
import SanchalakSamitiData from "../../temp/sanchalakSamiti.json";
import Footer from "../../components/Footer/Footer";

function SanchalakSamitiPage() {
  return (
    <div className="sanchalak-samiti">
      <div className="sanchalak-samiti__heading-box">
        <h3 className="sanchalak-samiti__heading">संचालक समिति</h3>
      </div>
      <div className="sanchalak-samiti__content">
        {SanchalakSamitiData?.data?.map((el) => {
          return (
            <div className="sanchalak-samiti__member" id={el.id} key={el.id}>
              <img
                className="sanchalak-samiti__image"
                src={el.image}
                alt="kj"
              />
              <div className="sanchalak-samiti__member-info-box">
                <h3 className="sanchalak-samiti__heading">{el.post}</h3>: &nbsp;
                <p className="sanchalak-samiti__para"> श्री {el.name}</p>
              </div>
            </div>
          );
        })}
      </div>
      <Footer></Footer>
    </div>
  );
}

export default SanchalakSamitiPage;
